module.exports = __webpack_public_path__ + "static/img/start.2cc8716.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videoBg/Smena7/start.jpg
// module id = 8Ovv
// module chunks = 1